/* src/app/modules_v2/customer-portal/components/contact-portal/contact-portal.component.scss */
.cp-page {
  min-width: 0;
  max-height: none;
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: 12px;
}
.cp-header-text {
  min-width: 0;
}
.cp-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 36px 16px;
  text-align: center;
}
.cp-state > mat-icon {
  font-size: 44px;
  width: 44px;
  height: 44px;
  color: #d1d5db;
  margin-bottom: 6px;
}
.cp-state .cf-btn {
  margin-top: 10px;
}
.cp-state--error > mat-icon {
  color: var(--cf-error, #dc2626);
}
.cp-state__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #374151;
}
.cp-state__sub {
  margin: 0;
  max-width: 520px;
  font-size: 13px;
  line-height: 1.5;
  color: var(--cf-text-muted, #6b7280);
}
.cp-section__label {
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--cf-text-muted, #6b7280);
}
.cp-link {
  display: flex;
  gap: 8px;
  align-items: center;
}
.cp-link__input {
  flex: 1;
  min-width: 0;
  height: 34px;
  padding: 6px 10px;
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: 8px;
  background: var(--cf-bg, #f4f6f8);
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    monospace;
  font-size: 12px;
  color: var(--cf-text, #1a1d23);
}
.cp-link__input:focus {
  outline: none;
  border-color: #c5d94a;
}
.cp-warning,
.cp-hint {
  display: flex;
  gap: 6px;
  align-items: flex-start;
  margin: 12px 0 0;
  font-size: 13px;
  line-height: 1.4;
}
.cp-warning mat-icon,
.cp-hint mat-icon {
  flex: 0 0 18px;
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.cp-warning {
  color: #92400e;
}
.cp-warning mat-icon {
  color: var(--cf-warning, #d97706);
}
.cp-hint {
  color: var(--cf-text-muted, #6b7280);
}
.cp-facts {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
  margin: 16px 0 0;
}
.cp-facts > div {
  padding: 10px 12px;
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: 8px;
}
.cp-facts dt {
  font-size: 12px;
  font-weight: 500;
  color: var(--cf-text-muted, #6b7280);
}
.cp-facts dd {
  margin: 2px 0 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--cf-text, #1a1d23);
}
.cp-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}
.cf-btn.cp-btn-danger.mat-mdc-button-base {
  color: var(--cf-error, #dc2626) !important;
}
.cf-btn.cp-btn-danger.mat-mdc-button-base:hover:not([disabled]) {
  border-color: #fecaca !important;
  background: #fef2f2 !important;
}
.cp-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  padding-top: 14px;
  border-top: 1px solid var(--cf-border, #e5e7eb);
  font-size: 13px;
  color: var(--cf-text-muted, #6b7280);
}
.cp-footer__btn {
  font-size: 13px;
  color: var(--cf-text-muted, #6b7280);
}
@media (max-width: 600px) {
  .cp-link {
    flex-wrap: wrap;
  }
  .cp-link .cp-link__input {
    flex-basis: 100%;
  }
}
/*# sourceMappingURL=contact-portal.component.css.map */
